define.alias("shared/modifiers/button", "settings/modifiers/button");